import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import {
  APQueryOptions,
  LONG_STALE_TIME,
  useAPQuery,
} from "../../providers/APQueryProvider";
import { APVehicleAspects } from "../../types/Vehicles";

export const getVehicleAspects = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["vehicle-aspects"],
    queryFn: (): Promise<APVehicleAspects> => {
      return fetchWithAuth<APVehicleAspects>("getVehicleAspects");
    },
    enabled: isQueryEnabled(options),
    staleTime: LONG_STALE_TIME,
  });
};
